import { StyledHero } from '@/components/styles';
import { Appointment, Picture, RoutedLink, Breadcrumbs } from '@/components';
import Swiper from 'react-id-swiper';
import { useTranslation } from 'react-i18next';

export default function Hero({ data, center, size, breadcrumbs, hiddenTablet, h1, asH1 }) {
  const { t } = useTranslation('global');
  const params = {
    slidesPerView: 1,
    preloadImages: false,
    resistanceRatio: 0,
    watchOverflow: true,
    parallax: true,
    keyboard: true,
    speed: 600,
    parallax: true,
    effect: 'fade',
    autoHeight: true,
    rebuildOnUpdate: true,
    shouldSwiperUpdate: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    preventInteractionOnTransition: true,
    renderPagination: () => (
      <StyledHero.Pagination>
        <StyledHero.Container>
          <div className="swiper-pagination"></div>
        </StyledHero.Container>
      </StyledHero.Pagination>
    ),
  };

  return (
    <StyledHero size={size} center={center} hiddenTablet={hiddenTablet}>
      <Swiper {...params}>
        {data.map((item, index) => {
          const {
            id,
            title,
            short_content: desc,
            appointment_button: button,
            image: imageFromProps,
            banner_alt,
            link,
            video,
            theme = 'light',
          } = item;

          const image = imageFromProps || {};
          const imageAlt = banner_alt || title || '';

          return (
            <StyledHero.Item key={id} theme={theme}>
              {!video && <StyledHero.Img>{Object.keys(image).length > 0 && <Picture {...image} alt={imageAlt} main={true}/>}</StyledHero.Img>}
              {video && (
                <StyledHero.Video>
                  <video autoplay="autoplay" loop="loop" muted="muted" playsinline="playsinline" src={video} poster={image?.desktop?.webp_x2}></video>
                </StyledHero.Video>
              )}

              <StyledHero.Content>
                {link && <RoutedLink to={link} component={StyledHero.Link} />}
                <StyledHero.Container>
                  {typeof h1 === "undefined" && <StyledHero.Title
                    data-swiper-parallax="-400"
                    data-swiper-parallax-duration="800"
                    data-swiper-parallax-opacity="0"
                    as={asH1 ? 'h1' : 'h2'}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />}
                  {typeof h1 !== "undefined" && <StyledHero.TitleH1
                    data-swiper-parallax="-400"
                    data-swiper-parallax-duration="800"
                    data-swiper-parallax-opacity="0"
                    dangerouslySetInnerHTML={{ __html: title }}
                  />}
                  
                  {desc && (
                    <StyledHero.Desc
                      data-swiper-parallax="-300"
                      data-swiper-parallax-duration="800"
                      data-swiper-parallax-opacity="0"
                      as="div"
                      dangerouslySetInnerHTML={{ __html: desc }}
                    />
                  )}
                  {(link || button) && (
                    <StyledHero.Footer>
                      {button && (
                        <StyledHero.Button
                          data-swiper-parallax-opacity="0"
                          data-swiper-parallax="-200"
                          data-swiper-parallax-duration="800"
                        >
                          <Appointment />
                        </StyledHero.Button>
                      )}
                      {link && (
                        <StyledHero.More
                          data-swiper-parallax="-200"
                          data-swiper-parallax-duration="800"
                          data-swiper-parallax-opacity="0"
                        >
                          <span>{t('main.banner.link')}</span>
                        </StyledHero.More>
                      )}
                    </StyledHero.Footer>
                  )}
                  {breadcrumbs?.length > 0 && index === 0 && (
                    <Breadcrumbs items={breadcrumbs} theme={theme} emitSchema />
                  )}
                </StyledHero.Container>
              </StyledHero.Content>
            </StyledHero.Item>
          );
        })}
      </Swiper>
    </StyledHero>
  );
}
